import { supportEmail, supportPhoneNumber, youtubeUrl } from '@helpers/constants';
import {
    twitterUrl,
    facebookUrl,
    linkedInUrl,
    instagramUrl,
} from '@helpers/constants';

export const contactUsForm = {
    title: 'Write to us',
    ctaText: 'Send Message',
    fields: [
        {
            id: 'name',
            label: 'Name',
            placeholder: 'Enter your name',
            type: 'text',
        },
        {
            id: 'email',
            label: 'Email',
            placeholder: 'Enter your email ID',
            type: 'text',
        },
        {
            id: 'mobile',
            label: 'Phone Number',
            placeholder: 'Enter your phone number',
            type: 'text',
        },
        {
            id: 'message',
            label: 'Message',
            placeholder: 'Enter message here',
            type: 'textarea',
        },
    ],
};

export const contactDetails = [
    {
        icon: '/images/contact-us/call-us.svg',
        label: 'Call Us',
        value: supportPhoneNumber,
        type: 'phone',
    },
    {
        icon: '/images/contact-us/email-us.svg',
        label: 'Email Us',
        value: supportEmail,
        type: 'email',
    },
];

export const addressDetails = [
    {
        icon: '/images/contact-us/location.svg',
        label: 'Mailing address',
        value: `86/1, 2nd Floor Maruti Complex, New Thippasandra Main Road, Next To Anjaneya Temple, Bengaluru, Karnataka, 560075`,
        type: 'address',
    },
    {
        icon: '/images/contact-us/location.svg',
        label: 'Registered address',
        value: `86/1, 2nd Floor Maruti Complex, New Thippasandra Main Road, Next To Anjaneya Temple, Bengaluru, Karnataka, 560075 `,
        type: 'address',
    },
];

export const socialMediaIcons = [
    {
        src: '/images/contact-us/linkedIn.svg',
        alt: 'linkedin-logo',
        link: linkedInUrl,
    },
    {
        src: '/images/contact-us/youtube.svg',
        alt: 'youtube-logo',
        link: youtubeUrl,
    },
    {
        src: '/images/contact-us/instagram.svg',
        alt: 'instagram-logo',
        link: instagramUrl,
    },
    {
        src: '/images/contact-us/X.svg',
        alt: 'x-logo',
        link: twitterUrl,
    },
    {
        src: '/images/contact-us/facebook.svg',
        alt: 'facebook-logo',
        link: facebookUrl,
    },
];
